(() => {
  function init() {
    document.querySelectorAll('.sk-advertorial').forEach(page => {
      if (page.dataset.ready) return;
      page.dataset.ready = 'true';
      const bar = page.querySelector('[data-sk-sticky]');
      const intro = page.querySelector('.sk-intro');
      const end = page.querySelector('.sk-finale');
      if (!bar || !intro || !end) return;
      let queued = false;
      const update = () => {
        bar.hidden = intro.getBoundingClientRect().bottom > 0 || end.getBoundingClientRect().top < window.innerHeight;
        queued = false;
      };
      window.addEventListener('scroll', () => {
        if (!queued) { queued = true; requestAnimationFrame(update); }
      }, { passive: true });
      window.addEventListener('resize', update);
      update();
    });
  }
  init();
  document.addEventListener('shopify:section:load', init);
})();